// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/WhatsappMessageTemplates_SalvarInput.php
// Do not edit by hand — edit the PHP InputContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * InputContract for POST /config/whatsapp_message_templates/salvar
 *
 * Creates or updates a WhatsApp message template.
 * If template_id is provided, updates existing; otherwise creates new.
 */
import { registerContract } from './validate'

export interface WhatsappMessageTemplates_SalvarInput {
template_id?: number
template_name?: string
template_content?: string
template_type?: string
template_media_url?: string
is_active?: number
franquia_ids?: number[]
}

registerContract('WhatsappMessageTemplates_SalvarInput', {
  template_id:        { type: 'number',  required: false },
  template_name:      { type: 'string',  required: false },
  template_content:   { type: 'string',  required: false },
  template_type:      { type: 'string',  required: false },
  template_media_url: { type: 'string',  required: false },
  is_active:          { type: 'number',  required: false },
  franquia_ids:       { type: 'array',   required: false },
})
